import { render } from "./Chats.vue?vue&type=template&id=26892956&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"

import "./Chats.vue?vue&type=style&index=0&id=26892956&scoped=true&lang=css"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26892956"]])

export default __exports__